import {connect} from 'react-redux';
import ShiftDetailsDialog from '../../components/dialogs/ShiftDetailsDialog';
import {appDialogShiftDetailsClose} from "../../actions/appAction";
import {getSchedule} from '../../actions/scheduleAction';

const mapStateToProps = state => {
    return {
        shiftId: state.app.dialogShiftDetailsShiftId,
        roles: state.authorization.roles
    }
};

const mapDispatchToProps = dispatch => {
    return {
        close: () => {
            dispatch(appDialogShiftDetailsClose())
        },
        reloadSchedule: () => {
            dispatch(getSchedule())
        }
    }
};

const ShiftDetailsDialogContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ShiftDetailsDialog);

export default ShiftDetailsDialogContainer;